import React from 'react';

import { Dialog } from '@shared/components';
import { UPLOAD_OPTIONS } from '@shared/constants';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import DoneIcon from '@assets/icons/done-green.svg';

import useStyles from './style';

const noop = () => {};

const UploadDialog = ({
  isOpen = false,
  uploadAction = null,
  onChange = noop,
  onClose = noop,
  handleUpload = noop,
  selectedFile = null,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={isOpen}
      onClose={onClose}
      classes={{
        paper: classes.uploadDialog,
      }}
    >
      <Dialog.Title hasClose></Dialog.Title>
      <Dialog.Content>
        <Typography variant='h5' className='bold-font'>
          Choose Upload Action
        </Typography>
        <RadioGroup
          className='d-flex f-align-center flex-row mt-2'
          aria-label='extensionType'
          name='extensionType'
          value={uploadAction}
          onChange={onChange}
        >
          <FormControlLabel
            value={UPLOAD_OPTIONS.UPDATE_RULE}
            control={
              <Radio
                classes={{
                  root: classes.radioButton,
                }}
              />
            }
            label='Create 24/7 Forwarding Rule'
          />
          <FormControlLabel
            value={UPLOAD_OPTIONS.CREATE_OR_UPDATE_RULE}
            control={
              <Radio
                classes={{
                  root: classes.radioButton,
                }}
              />
            }
            label='Create/Update Advanced Rules'
          />
          <FormControlLabel
            value={UPLOAD_OPTIONS.DELETE_RULE}
            control={
              <Radio
                classes={{
                  root: classes.radioButton,
                }}
              />
            }
            label='Bulk Delete'
          />
        </RadioGroup>
      </Dialog.Content>
      <Dialog.Actions>
        <div>
          <Button variant='outlined' className='mr-4 mb-4' onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            className='mr-4 mb-4'
            onClick={handleUpload}
            disabled={!uploadAction}
          >
            Upload
          </Button>
        </div>
      </Dialog.Actions>
    </Dialog>
  );
};
export default UploadDialog;
